module.exports = __webpack_public_path__ + "img/12-3.b1442666.jpg";